import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { AdminService } from '../../../services/admin.service';
import { AdminCallRow } from '../../../models/admin-call.model';
import { LatencyPipe } from '../../../../../core/pipes';

@Component({
  selector: 'app-calls-preview-card',
  standalone: false,
  templateUrl: './calls-preview-card.html',
})
export class CallsPreviewCard implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  rows: AdminCallRow[] = [];
  isLoading = true;

  constructor(private adminService: AdminService) {}

  ngOnInit(): void {
    this.adminService.getCalls({ perPage: 5 })
      .pipe(takeUntil(this._destroy$))
      .subscribe(({ rows }) => {
        this.rows = rows;
        this.isLoading = false;
      });
  }

  /** Same threshold the `latency` pipe uses to switch to seconds. */
  isSlow(row: AdminCallRow): boolean {
    return row.latencyMs >= LatencyPipe.SLOW_MS;
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
